module.exports = __webpack_public_path__ + "img/television.9b840825.svg";